(function () {
  Flint.file('mframework/views/filterOption.js', function (require) {
    Flint.view('FilterOption', function (view, on, $) {
      var context = initContext(view, {
        colors: atom()
      });

      var pro = initPro(view, {
        children: atom(),
        initialSelected: atom(),
        selected: M.defaultAtom(false),
        innerStyle: M.mapAtom({})
      });

      var selected = atom(pro.initialSelected.get());

      pro.selected.react(function (propSelected) {
        selected.set(propSelected);
      }, { when: function when() {
          return pro.selected.get() != null;
        } });

      var onClick = function onClick(e) {
        var nextSelected = !selected.get();

        if (pro.selected.get() == null) {
          selected.set(nextSelected);
        }

        if (view.props.onChange) {
          view.props.onChange({ selected: nextSelected });
        }
      };

      var hovering = atom(false);
      hovering.reactor(function (hovering) {
        if (view.props.onHover) view.props.onHover({ hovering: hovering });
      }).start();view.render(function () {
        return view.el(
          ['filterOption', 1],
          {
            onClick: onClick,
            onMouseEnter: function () {
              return hovering.set(true);
            },
            onMouseLeave: function () {
              return hovering.set(false);
            },
            style: IMap({
              flexGrow: 1,
              alignSelf: 'stretch',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              borderRadius: 8,
              padding: 4,
              cursor: 'pointer',
              fontSize: 13,
              border: '1px solid #d5dade',
              background: selected.get() ? context.colors.get().accent : 'linear-gradient(to bottom, #f1f1f6 0%, #c1c1d2 100%)',
              color: selected.get() ? 'white' : 'black'
            }).merge(pro.innerStyle.get()).toJS()
          },
          pro.children.get()
        );
      });
    });
  })
})();
//# sourceMappingURL=filterOption.js.map
